/**
 * FE#447 — the request-only clock fields a UI attaches when it creates a message or moves its due time.
 *
 * A dueDate is minted from this machine's clock (the user picks a time relative to the clock they see). The
 * server turns `clientNowMs` into `creatorClockSkewMs` — stored next to the dueDate — so that every later
 * "is it due yet?" judgement is made on the clock that minted it. Never persisted itself.
 */
import { systemClientClock } from '@bt-common/scheduling';

export interface ClientClockFields {
    clientNowMs: number;
    clientTzOffsetMin: number;
}

export function clientClockFields(): ClientClockFields {
    const { nowMs, tzOffsetMin } = systemClientClock();
    return { clientNowMs: nowMs, clientTzOffsetMin: tzOffsetMin };
}

export function withClientClock<T extends object>(entity: T): T & ClientClockFields {
    return { ...entity, ...clientClockFields() };
}
